import { privateApi } from "../api/axios";


export const getJobsOpenings = async () => {
    try {
        const response = await privateApi.get("api/jobsopenings");
        return response;
    } catch (error) {
        throw error;
    }
}

export const deleteJobOpening = async (id: number) => {
    try {
        const response = await privateApi.delete(`api/jobsopenings/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const addJobOpening = async (data: any) => {
    try {
        const response = await privateApi.post("api/jobsopenings", data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const patchJobOpening = async (id: number, data: any) => {
    try {
        const response = await privateApi.patch(`api/jobsopenings/${id}`, data);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getJobOpening = async (id: number) => {
    try {
        const response = await privateApi.get(`api/jobsopenings/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
}